const peMapping = {
    'Isolated Private Endpoint (Qty)': 'Isolated Private Endpoint (Qty)',
    'Enterprise Private Endpoint (Qty)': 'Enterprise Private Endpoint (Qty)',
    SubType: 'SubType',
};
const devSecOpsMapping = {
    'Notification DL': 'Notification DL',
    'Argo CD Cluster': 'Argo CD Cluster',
    'Argo CD Parent Url': 'Argo CD Parent Url',
    'ACR Name': 'ACR Name',
    'ACR RG Name': 'ACR RG Name',
    'ACR Subscription Id': 'ACR Subscription Id',
    'Privileged AD Group': 'Privileged AD Group',
    'Non Privileged AD Group': 'Non Privileged AD Group',
    'Variable Group': 'Variable Group',
    'Email Notification Group': 'Email Notification Group',
    'Source Code Repo Urls': 'Source Code Repo Urls',
    'Argo CD Repo Branches': 'Argo CD Repo Branches',
    'Argo CD Repo Url': 'Argo CD Repo Url',
    'Pipeline Urls': 'Pipeline Urls',
    'Virtual Service Urls': 'Virtual Service Urls',
    'Argo CD Url': 'Argo CD Url',
};

const jfrogMapping = {
    'IDX System Account (OKTA) Name': 'IDX System Account (OKTA) Name',
    'IDX System Account (OKTA) Exists': 'IDX System Account (OKTA) Exists',
};
const MappingLabel = {
    // PE
    ...peMapping,
    ...devSecOpsMapping,
    ...jfrogMapping,
    // Other Configurations
    'Blob Mpe Name': 'BLOB MPE Name',
    blobMpeName: 'BLOB MPE Name',
    'Datalake Mpe Name': 'DATALAKE MPE Name',
    datalakeMpeName: 'DATALAKE MPE Name',
    'Datalake Storage Id': 'Datalake Storage ID',
    dataLakeStorageId: 'Datalake Storage ID',
    'Managed Vnet Ir Name': 'Managed VNET IR Name',
    managedVnetIrName: 'Managed VNET IR Name',
    'Adls Link Service Name': 'ADLS Link Service Name',
    adlsLinkServiceName: 'ADLS Link Service Name',
    'Dbk Link Service Name': 'DBK Link Service Name',
    dbkLinkServiceName: 'DBK Link Service Name',
    // Data Factory
    'Master Adf Name': 'Master ADF Name',
    masterAdfName: 'Master ADF Name',
    // Data Bricks Cluster
    'Dbkworkspace Id': 'DBK Workspace ID',
    workspaceId: 'Workspace ID',
    'Workspace Url': 'Workspace URL',
    workspaceUrl: 'Workspace URL',
    'Dbkhive Url': 'DBK Hive URL',
    hiveUrl: 'Hive URL',
    'Dbk Hive Url': 'DBK Hive URL',
    'Dbk Mpe Name': 'DBK MPE Name',
    mpeName: 'MPE Name',
    'Mpe Name': 'MPE Name',
    'Key Vault Link Service Name': 'KEYVAULT Link Service Name',
    keyVaultLinkServiceName: 'KEYVAULT Link Service Name',
    'Blob Link Service Name': 'BLOB Link Service Name',
    blobLinkServiceName: 'BLOB Link Service Name',
    Others: 'Other Configurations',
    'Adls Ad Group Id': 'ADLS Ad Group Id',
    idmRequestNumber: 'IDM Request No',
    metadataXML: 'Metadata XML',
    metadataURL: 'Metadata URL',
    adoProjectName: 'ADO Project Name',
    projectAdminADGroup: 'Project Admin AD Group',
    adoProjectUrl: 'ADO Project URL',
    addMembersRequestNumber: 'Add Members Request Number',
    removeMembersRequestNumber: 'Remove Members Request Number',
    fortifyUrl: 'Fortify URL',
    snykUrl: 'Snyk URL',
    scaOrganizationName: 'SCA Organization Name',
    scaOrganizationId: 'SCA Organization Id',
    sonarQubeUrl: 'Sonarqube URL',
    serviceAccountRequestNumber: 'SonarQube Service Account Request',
    'Metadata XML': 'Metadata XML',
    'De Dbk Cluster Name': 'DE DBK Cluster Name',
    'Ds Dbk Cluster Name': 'DS DBK Cluster Name',
    'Adls Container Name': 'ADLS Container Name',
    'Adf Dbk Link Service Name': 'ADF DBK Link Service Name',
    'Adf Dbk Mpe Name': 'ADF DBK MPE Name',
    // Added for RI001.A provsioing details
    dbkDeClusterName: 'DBK DE Cluster Name',
    dbkDsClusterName: 'DBK DS Cluster Name',
    adfDbkLinkServiceName: 'ADF DBK Link Service Name',
    adlsContainerName: 'ADLS Container Name',
    adfDbkMpeName: 'ADF DBK MPE Name',
    'Dbk Ds Cluster Name': 'DBK DS Cluster Name',
    'Dbk De Cluster Name': 'DBK DE Cluster Name',
    'Adf De Dbk Mpe Name': 'ADF DE DBK MPE Name',
    'Adf Ds Dbk Mpe Name': 'ADF DS DBK MPE Name',
    'Adf De Dbk Link Service Name': 'ADF DE DBK Link Service Name',
    'Adf Ds Dbk Link Service Name': 'ADF DS DBK Link Service Name',
    'Adf De Managed Vnet Ir Name': 'ADF DE Managed VNET IR Name',
    'Adf Ds Managed Vnet Ir Name': 'ADF DS Managed VNET IR Name',
    // dbkDsClusterName: 'DBK DS Cluster Name',
    // dbkDeClusterName: 'DBK DE Cluster Name',
    adfDeDbkMpeName: 'ADF DE DBK MPE Name',
    adfDsDbkMpeName: 'ADF DS DBK MPE Name',
    adfDeDbkLinkServiceName: 'ADF DE DBK Link Service Name',
    adfDsDbkLinkServiceName: 'ADF DS DBK Link Service Name',
    adfDeManagedVnetIrName: 'ADF DE Managed VNET IR Name',
    adfDsManagedVnetIrName: 'ADF DS Managed VNET IR Name',
    dataFactory: 'dataFactoryType',
    dataBricksCluster: 'clusterType',
    'data-factory': 'data-factory-type',
    'data-lake-storage': 'storage-type',
    'data-bricks-cluster': 'data-bricks-cluster-type',
    Sector_adls_container_name: 'Sector ADLS Container Name',
    'Sector Adls Container Name': 'Sector ADLS Container Name',
    'Sector adls container name': 'Sector ADLS Container Name',
    sectorAdlsContainerName: 'Sector ADLS Container Name',
    dbkHiveUrl: 'DBK Hive URL',
    dbkMpeName: 'DBK MPE Name',
    mypamSafeName: 'Service Account myPAM Safe Name',
    mypamSafeOwnerGpid: 'Service Account myPAM Safe Owner GPID',
    sonarqubeUrl: 'SonarQube URL',
    sonarServiceConnection: 'SonarQube Service Connection',
    sonarProjectNamesList: 'SonarQube Project Names',
    scaUrl: 'SCA URL',
    sastUrl: 'SAST URL',
    sastAppName: 'SAST App Name',
    sastAppVersion: 'SAST App Version',
    sastRequestNumber: 'SAST MyIDM Request Number',
    scaAdminRequestNumber: 'SCA Admin MyIDM Request Number',
    scaCollaboratorRequestNumber: 'SCA Collaborator MyIDM Request Number',
    // sso okta
    'IDX Attribute Available': 'IDX Attribute Available',
    'IDX Attribute': 'IDX Attribute',
    'Logout URL Available': 'Logout URL Available',
    'SAML Assertion required for Role': 'SAML Assertion required for Role',
    'IDX Role Attribute': 'IDX Role Attribute',
    'Assertion Consumer Service (ACS) URL': 'Assertion Consumer Service (ACS) URL',
    'Application Client ID': 'Application Client ID',
    'MFA Required': 'MFA Required',
    'Destination URL': 'Destination URL',
    'Recipient URL': 'Recipient URL',
    'SSO Owner': 'SSO Owner',
    //   Optional RI003O
    'topic-name': 'Topic Name',
    'consumer-group': 'Consumer Group',
    'consumer-id': 'Consumer ID',
    'producer-id': 'Producer ID',
    iteApplicationName: 'ITE Application Name',
    // Azure PGT SAP SLES 15VM
    'SAP Environment': 'SAP Environment',
    'URL Path': 'URL Path',
    FQDNS: 'FQDNS',
    'HP Protocol': 'HP Protocol',
    // AZURE PGT SAP SLES VM
    'SAP SID ID': 'SAP SID ID',
    'SAP GID ID': 'SAP GID ID',
    'SAP Features': 'SAP Features',
    // PGCS Azure SQL IaaS
    'CMP Provisioning Request': 'CMP Provisioning Request',
    // AWS RI003 section field labels
    'Ad Group': 'Active Directory Group',
    'Ou Name': 'OU Name',
    'Ou Id': 'OU ID',
    'Shared Network Account Id': 'Shared Network Account ID',
    'Aws Account Onboard Order Id': 'AWS Account Onboard Order ID',
    'Eks Role Name': 'EKS Role Name',
    'Istio Gateway Url': 'Istio Gateway URL',
    'Eks Account Id': 'EKS Account ID',
    'Eks Namespace': 'EKS Namespace',
    'Eks Target Role Name': 'EKS Target Role Name',
    'Db Name': 'Database Name',
    'Db Version': 'Database Version',
    'Rds Name': 'RDS Instance Name',
    'Sql Account Name': 'SQL Account Name',
    'Vpc Id': 'VPC ID',
    'Vpc Name': 'VPC Name',
    // AWS
    'Subnet ID': 'Subnet ID',
    'VPC ID': 'VPC ID',
    'OS Image': 'OS Image',
    'Account ID': 'Account ID',
    'Oracle RDS Instance Name': 'Oracle RDS Instance Name',
    'Oracle Database Edition': 'Oracle Database Edition',
    'Oracle Database Version': 'Oracle Database Version',
    'SQL RDS Instance Name': 'SQL RDS Instance Name',
    'SQL Database Edition': 'SQL Database Edition',
    'SQL Database Version': 'SQL Database Version',
    'PostgreSQL RDS Instance Name': 'PostgreSQL RDS Instance Name',
    'PostgreSQL Database Edition': 'PostgreSQL Database Edition',
    'PostgreSQL Database Version': 'PostgreSQL Database Version',
    'S3 Bucket ARN': 'S3 Bucket ARN',
    'AWS Account ID': 'AWS Account ID',
    'RDS Instance Name': 'RDS Instance Name',
    'DB Name': 'DB Name',
    'DB Instance Type': 'DB Instance Type',
    'RDS Instance ARN': 'RDS Instance ARN',
    'RDS Instance Address': 'RDS Instance Address',
    'RDS Security Group ID': 'RDS Security Group ID',
    'RDS Subnet Group Name': 'RDS Subnet Group Name',
    'RDS Subnet Group ARN': 'RDS Subnet Group ARN',
    'DynamoDB Table ARN': 'DynamoDB Table ARN',
    'AWS Cloud Onboarding Order ID': 'AWS Cloud Onboarding Order ID',
    'AWS Email Address': 'AWS Email Address',
    'AWS Organizational Unit ID': 'AWS Organizational Unit ID',
    'AWS Organizational Unit Name': 'AWS Organizational Unit Name',
    // EDAP AKS Namespace
    ' Certificate Retrieval URL': 'Certificate Retrieval URL',
    // Cloud Onboarding
    'AWS Account Name': 'AWS Account Name',
    'OU Name': 'OU Name',
    'OU ID': 'OU ID',

    // PostgreSQL Flexible DB
    'Storage Size (GB)': 'Storage Size (GB)',
    // MySQL Flexible DB
    'MySQL Name': 'MySQL Name',
    'MySQL Instance Name': 'MySQL Instance Name',
    'GMSA Service Account': 'GMSA Service Account',
    'GMSA Computer Group': 'GMSA Computer Group',
    // VS
    'SPC Name': 'SPC Name',
    'Key Vault Region': 'Key Vault Region',
    // EDAP NP
    'OS Type': 'OS Type',
    'OS Disk Type': 'OS Disk Type',
    'OS Disk Size (GB)': 'OS Disk Size (GB)',
    'EDAP Platform Owner': 'EDAP Platform Owner',
    'CMP Provisioning request': 'CMP Provisioning request',
    'OS SKU': 'OS SKU',
    // Private Cloud SQL IaaS
    'VLAN Name': 'VLAN Name',
    'VLAN Type': 'VLAN Type',
    'OS Template': 'OS Template',
    'CPU (vCPUs)': 'CPU (vCPUs)',
    'Memory (GB)': 'Memory (GB)',
    'Expected DB Size(GB)': 'Expected DB Size(GB)',
    'SQL Version': 'SQL Version',
    'SQL Server Collation': 'SQL Server Collation',
    'DB National Character Set': 'DB National Character Set',
    'DB Character Set': 'DB Character Set',
    'MyPam Safe Name ': 'MyPAM Safe Name',
    // Azure Oracle Exadata
    'VM Cluster': 'VM Cluster',
    'SGA Size (GB)': 'SGA Size (GB)',
    'PGA Size (GB)': 'PGA Size (GB)',
    'CPU Count': 'CPU Count',
};

export default MappingLabel;
